module.exports = __webpack_public_path__ + "img/37.c26774a0.jpg";